import React, { useState } from 'react';
import RadioButton from '../components/common/RadioButton';
import { useNavigate } from 'react-router-dom';
import { useCancelUserSubscriptionMutation } from '../redux/apiSlice';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { Loader2 } from 'lucide-react';

const reasons = [
  { label: 'Cost - The subscription is too expensive', value: 'cost' },
  {
    label: 'Content - The content does not meet my expectations or needs',
    value: 'content',
  },
  {
    label:
      'User Experience - I found the platform difficult to use and navigate',
    value: 'user-experience',
  },
  {
    label: 'Technical Issues - I experienced technical problems/bugs',
    value: 'technical-issues',
  },
  { label: 'Other - Please Specify', value: 'other' },
];

const CancelSubscription = () => {
  const navigate = useNavigate();
  const [cancelUserSubsription, { isLoading }] =
    useCancelUserSubscriptionMutation();
  const [selectedReason, setSelectedReason] = useState('');
  const [otherReason, setOtherReason] = useState('');
  const userDetails = useSelector((state: any) => state.app.user);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedReason(event.target.value);
    if (event.target.value !== 'other') {
      setOtherReason('');
    }
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (selectedReason === 'other' && !otherReason.trim()) {
      toast.error('Please specify your reason for cancellation');
      return;
    }

    const cancelReason =
      selectedReason === 'other' ? otherReason : selectedReason;

    const response = await cancelUserSubsription({
      user_id: userDetails?.user,
      cancel_reason: cancelReason,
    }).unwrap();

    console.log('response', response);
    toast.success('Subscription cancelled successfully!');
    navigate('/courses');
    console.log('Selected reason for cancellation:', cancelReason);
  };

  return (
    <div className="flex flex-col text-[24px] font-roboto pt-4 px-24 gap-5 bg-gray-50 min-h-screen">
      <p>
        We're sorry to see you go. Please take a moment to let us know why
        you're canceling your subscription so we can improve your experience in
        the future.
      </p>
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col gap-4 mt-3">
          {reasons.map((reason) => (
            <RadioButton
              key={reason.value}
              label={reason.label}
              value={reason.value}
              checked={selectedReason === reason.value}
              onChange={handleRadioChange}
              labelSize="text-[24px]"
            />
          ))}

          {selectedReason === 'other' && (
            <div className="ml-8 mt-2">
              <input
                type="text"
                value={otherReason}
                onChange={(e) => setOtherReason(e.target.value)}
                placeholder="Please specify your reason..."
                className="w-full px-3 py-2 border border-gray-300 rounded-md text-[16px] focus:outline-none focus:ring-2 focus:ring-[#023f81] focus:border-transparent"
                required
              />
            </div>
          )}
        </div>

        <div className="flex justify-center mt-6">
          <button
            type="submit"
            className="px-6 py-2 text-[14px] h-[43px] bg-[#023f81] text-white rounded "
            disabled={isLoading}
          >
            {isLoading ? (
              <Loader2 className="animate-spin h-6 w-6 m-auto" />
            ) : (
              'Submit and Cancel Subscription'
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CancelSubscription;
